import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventInboxCalling } from 'entities/Inbox/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type CallHistoryStore } from 'pages/conversations/pages/calls/ui/CallHistory'

export const useEventInboxCalling = (callHistoryStore: CallHistoryStore) => {
  const { websocket } = useEntitiesContext()
  const handler = (data: IResponseEventInboxCalling) => {
    callHistoryStore.updateInboxCalling(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.InboxCalling, handler), [])
}
